import axios from 'axios'
import modals from '~/lib/modals'

export default {
  mixins: [modals],
  data () {
    return {
      nocfoAccounts: [],
      nocfoLevelCache: {
        '0': 0
      }
    }
  },
  methods: {
    loadNocfoAccounts () {
      return new Promise(async (resolve) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/accounts.json?apikey=' + this.apiKey)
        } catch (e) {
          this.showError(e)
          resolve([])
          return
        }
        this.nocfoAccounts = response.data
        resolve(response.data)
      })
    },
    nocfoAccountTitle (account) {
      return this.nocfoAccountPadding(account) + (parseInt(account.number) ? account.number + ' ' : '') + account.name
    },
    nocfoAccountPadding (account) {
      const p = account.parentid
      const i = account.id
      if (!this.nocfoLevelCache[p]) {
        this.nocfoLevelCache[p] = 0
      }
      this.nocfoLevelCache[i] = this.nocfoLevelCache[p] + 1
      return '&nbsp;'.repeat(this.nocfoLevelCache[i] * 4)
    },
    async nocfoAccountDialog (obj, field) {
      const accounts = await this.loadNocfoAccounts()
      this.showDialog({
        title: this._('NoCFO account'),
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            handler: (data) => {
              obj[field] = data.account
            }
          }
        ],
        fields: [
          {
            title: this._('Account'),
            type: 'select',
            name: 'account',
            options: accounts.map(a => { return { value: a.number, name: this.nocfoAccountTitle(a), disabled: !parseInt(a.number) } }),
            defaultValue: parseInt(obj[field]) ? obj[field] : null
          }
        ]
      })
    },
    async nocfoSync () {
      const payload = { nocfosync: 1 }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, payload)
      } catch (e) {
        this.showError(e)
        return
      }
      this.showNotification(this._('Synchronization scheduled. It should be complete in a few minutes.'))
    }
  }
}
